import {
  MAX_TEXT_HEIGHT
} from './const';

export function rollup(cls) {
  const elems = document.querySelectorAll(cls);
  elems.forEach(elem => {
    const elemHeight = elem.offsetHeight;
    if (elemHeight > MAX_TEXT_HEIGHT && !elem.classList.contains('roll')) {
      elem.classList.add('roll');
      elem.addEventListener('click', elemClickHandler);
    }
  });
}

function elemClickHandler(evt) {
  if (evt.target.tagName === 'BUTTON') {
    this.classList.remove('roll');
    this.removeEventListener('click', elemClickHandler);
  }
}
